// ? STRENGTH HERO IMAGES
import STR1 from '../../../assets/img/heroes/strength/HERADIAS.jpg';
import STR2 from '../../../assets/img/heroes/strength/TITAN.jpg';
import STR3 from '../../../assets/img/heroes/strength/BRADY.jpg';
import STR4 from '../../../assets/img/heroes/strength/XIAHOU DUN.jpg';
import STR5 from '../../../assets/img/heroes/strength/BEILOU SHIMEN.jpg';
import STR6 from '../../../assets/img/heroes/strength/TIAMAT.jpg';
import STR7 from '../../../assets/img/heroes/strength/DR MADD.jpg';
import STR8 from '../../../assets/img/heroes/strength/BONNIE.jpg';
import STR9 from '../../../assets/img/heroes/strength/CONDOR.jpg';
import STR10 from '../../../assets/img/heroes/strength/GALAHAD.jpg';
import STR11 from '../../../assets/img/heroes/strength/LEONIDAS.jpg';
import STR12 from '../../../assets/img/heroes/strength/RAKER.jpg';
import STR13 from '../../../assets/img/heroes/strength/BORGON.jpg';
import STR14 from '../../../assets/img/heroes/strength/RAHOTEP.jpg';
import STR15 from '../../../assets/img/heroes/strength/TARTORUS.jpg';
import STR16 from '../../../assets/img/heroes/strength/MULAN.jpg';
import STR17 from '../../../assets/img/heroes/strength/LULU.jpg';
import STR18 from '../../../assets/img/heroes/strength/PHOBOS.jpg';
import STR19 from '../../../assets/img/heroes/strength/WENDY.jpg';
import STR20 from '../../../assets/img/heroes/strength/CHERITH.jpg';
import STR21 from '../../../assets/img/heroes/strength/NAZAR.jpg';
import STR22 from '../../../assets/img/heroes/strength/GROM.jpg';
import STR23 from '../../../assets/img/heroes/strength/ARES.jpg';
import STR24 from '../../../assets/img/heroes/strength/ODIN.jpg';
import STR25 from '../../../assets/img/heroes/strength/MURDOCH.jpg';
import STR26 from '../../../assets/img/heroes/strength/MINOS.jpg';
import STR27 from '../../../assets/img/heroes/strength/VENOM.jpg';
import STR28 from '../../../assets/img/heroes/strength/DRAGOS.jpg';
import STR29 from '../../../assets/img/heroes/strength/BOMBOM.jpg';
import STR30 from '../../../assets/img/heroes/strength/APOLLO.jpg';
import STR31 from '../../../assets/img/heroes/strength/LILITH.jpg';
import STR32 from '../../../assets/img/heroes/strength/GIDEON.jpg';
import STR33 from '../../../assets/img/heroes/strength/GUAN YU.jpg';
import STR34 from '../../../assets/img/heroes/strength/WOLFRAM.jpg';
import STR35 from '../../../assets/img/heroes/strength/BURNINATOR.jpg';
import STR36 from '../../../assets/img/heroes/strength/LU BU.jpg';
import STR37 from '../../../assets/img/heroes/strength/ZHANG FEI.jpg';
import STR38 from '../../../assets/img/heroes/strength/ROCKMAN.jpg';

// ? AGILITY HERO IMAGES
import AGI1 from '../../../assets/img/heroes/agility/DI RENJIE.jpg';
import AGI2 from '../../../assets/img/heroes/agility/MOUSIA.jpg';
import AGI3 from '../../../assets/img/heroes/agility/LI BAI.jpg';
import AGI4 from '../../../assets/img/heroes/agility/DAIMON.jpg';
import AGI5 from '../../../assets/img/heroes/agility/YOUNG YANBING.jpg';
import AGI6 from '../../../assets/img/heroes/agility/ASURA.jpg';
import AGI7 from '../../../assets/img/heroes/agility/METHOS.jpg';
import AGI8 from '../../../assets/img/heroes/agility/FAWNA.jpg';
import AGI9 from '../../../assets/img/heroes/agility/FUMIKO.jpg';
import AGI10 from '../../../assets/img/heroes/agility/FUSILIA.jpg';
import AGI11 from '../../../assets/img/heroes/agility/SCARLET.jpg';
import AGI12 from '../../../assets/img/heroes/agility/HATTORI.jpg';
import AGI13 from '../../../assets/img/heroes/agility/PSION.jpg';
import AGI14 from '../../../assets/img/heroes/agility/STILLETO.jpg';
import AGI15 from '../../../assets/img/heroes/agility/PAIGE.jpg';
import AGI16 from '../../../assets/img/heroes/agility/CLARICE.jpg';
import AGI17 from '../../../assets/img/heroes/agility/ZORRO.jpg';
import AGI18 from '../../../assets/img/heroes/agility/LAPINA.jpg';
import AGI19 from '../../../assets/img/heroes/agility/DRAGON WARRIOR.jpg';
import AGI20 from '../../../assets/img/heroes/agility/ARLEQUIN.jpg';
import AGI21 from '../../../assets/img/heroes/agility/ESTRATH.jpg';
import AGI22 from '../../../assets/img/heroes/agility/FREYA.jpg';
import AGI23 from '../../../assets/img/heroes/agility/NIGHTSHADE.jpg';
import AGI24 from '../../../assets/img/heroes/agility/VINCE.jpg';
import AGI25 from '../../../assets/img/heroes/agility/SUN WUKONG.jpg';
import AGI26 from '../../../assets/img/heroes/agility/AIDEN.jpg';
import AGI27 from '../../../assets/img/heroes/agility/ELECTROS.jpg';
import AGI28 from '../../../assets/img/heroes/agility/MIKIO.jpg';
import AGI29 from '../../../assets/img/heroes/agility/DIANA.jpg';
import AGI30 from '../../../assets/img/heroes/agility/MINERVA.jpg';
import AGI31 from '../../../assets/img/heroes/agility/RAVEN.jpg';
import AGI32 from '../../../assets/img/heroes/agility/NEZHA.jpg';
import AGI33 from '../../../assets/img/heroes/agility/SOLUS.jpg';
import AGI34 from '../../../assets/img/heroes/agility/CAOCAO.jpg';
import AGI35 from '../../../assets/img/heroes/agility/MAGNOLIA.jpg';
import AGI36 from '../../../assets/img/heroes/agility/PENGWING.jpg';
import AGI37 from '../../../assets/img/heroes/agility/ZHAO YUN.jpg';

// ? INTELLIGENCE HERO IMAGES
import INT1 from '../../../assets/img/heroes/intelligence/HEGEMON.jpg';
import INT2 from '../../../assets/img/heroes/intelligence/XIA LING.jpg';
import INT3 from '../../../assets/img/heroes/intelligence/CELESTIUS.jpg';
import INT4 from '../../../assets/img/heroes/intelligence/ALBUS.jpg';
import INT5 from '../../../assets/img/heroes/intelligence/ATHENA.jpg';
import INT6 from '../../../assets/img/heroes/intelligence/LORELIE.jpg';
import INT7 from '../../../assets/img/heroes/intelligence/CHRONOS.jpg';
import INT8 from '../../../assets/img/heroes/intelligence/LIN LIN.jpg';
import INT9 from '../../../assets/img/heroes/intelligence/YANBING CAO.jpg';
import INT10 from '../../../assets/img/heroes/intelligence/FLEUR.jpg';
import INT11 from '../../../assets/img/heroes/intelligence/CHRONOS.jpg';
import INT12 from '../../../assets/img/heroes/intelligence/ELVIRA.jpg';
import INT13 from '../../../assets/img/heroes/intelligence/ABSALON.jpg';
import INT14 from '../../../assets/img/heroes/intelligence/DAMACUS.jpg';
import INT15 from '../../../assets/img/heroes/intelligence/ZEUS.jpg';
import INT16 from '../../../assets/img/heroes/intelligence/DAIO CHAN.jpg';
import INT17 from '../../../assets/img/heroes/intelligence/ZED.jpg';
import INT18 from '../../../assets/img/heroes/intelligence/ESTEIN.jpg';
import INT19 from '../../../assets/img/heroes/intelligence/PANDORA.jpg';
import INT20 from '../../../assets/img/heroes/intelligence/ARBORUS.jpg';
import INT21 from '../../../assets/img/heroes/intelligence/LOTUS.jpg';
import INT22 from '../../../assets/img/heroes/intelligence/PYRRUS.jpg';
import INT23 from '../../../assets/img/heroes/intelligence/UNA.jpg';
import INT24 from '../../../assets/img/heroes/intelligence/FLAVIA.jpg';
import INT25 from '../../../assets/img/heroes/intelligence/JEANNE.jpg';
import INT26 from '../../../assets/img/heroes/intelligence/CLEOPATRA.jpg';
import INT27 from '../../../assets/img/heroes/intelligence/NOSFERATU.jpg';
import INT28 from '../../../assets/img/heroes/intelligence/POSEIDON.jpg';
import INT29 from '../../../assets/img/heroes/intelligence/MAGICKA.jpg';
import INT30 from '../../../assets/img/heroes/intelligence/SAYA.jpg';
import INT31 from '../../../assets/img/heroes/intelligence/YUKI.jpg';
import INT32 from '../../../assets/img/heroes/intelligence/LUNARIA.jpg';
import INT33 from '../../../assets/img/heroes/intelligence/CRYSTAL.jpg';

export const heroes = [
  // ! STRENGTH HEROES
  {
    id: 'str-1',
    name: 'Heradias',
    portrait: STR1,
    category: 'Strength'
  },
  {
    id: 'str-2',
    name: 'Titan',
    portrait: STR2,
    category: 'Strength'
  },
  {
    id: 'str-3',
    name: 'Brady',
    portrait: STR3,
    category: 'Strength'
  },
  {
    id: 'str-4',
    name: 'Xiahou Dun',
    portrait: STR4,
    category: 'Strength'
  },
  {
    id: 'str-5',
    name: 'Beilou Shimen',
    portrait: STR5,
    category: 'Strength'
  },
  {
    id: 'str-6',
    name: 'Tiamat',
    portrait: STR6,
    category: 'Strength'
  },
  {
    id: 'str-7',
    name: 'Dr. Madd',
    portrait: STR7,
    category: 'Strength'
  },
  {
    id: 'str-8',
    name: 'Bonnie',
    portrait: STR8,
    category: 'Strength'
  },
  {
    id: 'str-9',
    name: 'Condor',
    portrait: STR9,
    category: 'Strength'
  },
  {
    id: 'str-10',
    name: 'Galahad',
    portrait: STR10,
    category: 'Strength'
  },
  {
    id: 'str-11',
    name: 'Leonidas',
    portrait: STR11,
    category: 'Strength'
  },
  {
    id: 'str-12',
    name: 'Raker',
    portrait: STR12,
    category: 'Strength'
  },
  {
    id: 'str-13',
    name: 'Borgon',
    portrait: STR13,
    category: 'Strength'
  },
  {
    id: 'str-14',
    name: 'Rahotep',
    portrait: STR14,
    category: 'Strength'
  },
  {
    id: 'str-15',
    name: 'Tartorus',
    portrait: STR15,
    category: 'Strength'
  },
  {
    id: 'str-16',
    name: 'Mulan',
    portrait: STR16,
    category: 'Strength'
  },
  {
    id: 'str-17',
    name: 'Lulu',
    portrait: STR17,
    category: 'Strength'
  },
  {
    id: 'str-18',
    name: 'Phobos',
    portrait: STR18,
    category: 'Strength'
  },
  {
    id: 'str-19',
    name: 'Wendy',
    portrait: STR19,
    category: 'Strength'
  },
  {
    id: 'str-20',
    name: 'Cherith',
    portrait: STR20,
    category: 'Strength'
  },
  {
    id: 'str-21',
    name: 'Nazar',
    portrait: STR21,
    category: 'Strength'
  },
  {
    id: 'str-22',
    name: 'Grom',
    portrait: STR22,
    category: 'Strength'
  },
  {
    id: 'str-23',
    name: 'Ares',
    portrait: STR23,
    category: 'Strength'
  },
  {
    id: 'str-24',
    name: 'Odin',
    portrait: STR24,
    category: 'Strength'
  },
  {
    id: 'str-25',
    name: 'Murdoch',
    portrait: STR25,
    category: 'Strength'
  },
  {
    id: 'str-26',
    name: 'Minos',
    portrait: STR26,
    category: 'Strength'
  },
  {
    id: 'str-27',
    name: 'Venom',
    portrait: STR27,
    category: 'Strength'
  },
  {
    id: 'str-28',
    name: 'Dragos',
    portrait: STR28,
    category: 'Strength'
  },
  {
    id: 'str-29',
    name: 'Bombom',
    portrait: STR29,
    category: 'Strength'
  },
  {
    id: 'str-30',
    name: 'Apollo',
    portrait: STR30,
    category: 'Strength'
  },
  {
    id: 'str-31',
    name: 'Lilith',
    portrait: STR31,
    category: 'Strength'
  },
  {
    id: 'str-32',
    name: 'Gideon',
    portrait: STR32,
    category: 'Strength'
  },
  {
    id: 'str-33',
    name: 'Guan Yu',
    portrait: STR33,
    category: 'Strength'
  },
  {
    id: 'str-34',
    name: 'Wolfram',
    portrait: STR34,
    category: 'Strength'
  },
  {
    id: 'str-35',
    name: 'Burninator',
    portrait: STR35,
    category: 'Strength'
  },
  {
    id: 'str-36',
    name: 'Lu Bu',
    portrait: STR36,
    category: 'Strength'
  },
  {
    id: 'str-37',
    name: 'Zhang Fei',
    portrait: STR37,
    category: 'Strength'
  },
  {
    id: 'str-38',
    name: 'Rockman',
    portrait: STR38,
    category: 'Strength'
  },

  // ! - END - STRENGTH HEROES

  // ! AGILITY HEROES
  {
    id: 'agi-1',
    name: 'Di Renjie',
    portrait: AGI1,
    category: 'Agility'
  },
  {
    id: 'agi-2',
    name: 'Mousia',
    portrait: AGI2,
    category: 'Agility'
  },
  {
    id: 'agi-3',
    name: 'Li Bai',
    portrait: AGI3,
    category: 'Agility'
  },
  {
    id: 'agi-4',
    name: 'Daimon',
    portrait: AGI4,
    category: 'Agility'
  },
  {
    id: 'agi-5',
    name: 'Young Yanbing',
    portrait: AGI5,
    category: 'Agility'
  },
  {
    id: 'agi-6',
    name: 'Asura',
    portrait: AGI6,
    category: 'Agility'
  },
  {
    id: 'agi-7',
    name: 'Methos',
    portrait: AGI7,
    category: 'Agility'
  },
  {
    id: 'agi-8',
    name: 'Fawna',
    portrait: AGI8,
    category: 'Agility'
  },
  {
    id: 'agi-9',
    name: 'Fumiko',
    portrait: AGI9,
    category: 'Agility'
  },
  {
    id: 'agi-10',
    name: 'Fusilia',
    portrait: AGI10,
    category: 'Agility'
  },
  {
    id: 'agi-11',
    name: 'Scarlet',
    portrait: AGI11,
    category: 'Agility'
  },
  {
    id: 'agi-12',
    name: 'Hattori',
    portrait: AGI12,
    category: 'Agility'
  },
  {
    id: 'agi-13',
    name: 'Psion',
    portrait: AGI13,
    category: 'Agility'
  },
  {
    id: 'agi-14',
    name: 'Stilleto',
    portrait: AGI14,
    category: 'Agility'
  },
  {
    id: 'agi-15',
    name: 'Paige',
    portrait: AGI15,
    category: 'Agility'
  },
  {
    id: 'agi-16',
    name: 'Clarice',
    portrait: AGI16,
    category: 'Agility'
  },
  {
    id: 'agi-17',
    name: 'Zorro',
    portrait: AGI17,
    category: 'Agility'
  },
  {
    id: 'agi-18',
    name: 'Lapina',
    portrait: AGI18,
    category: 'Agility'
  },
  {
    id: 'agi-19',
    name: 'Dragon Warrior',
    portrait: AGI19,
    category: 'Agility'
  },
  {
    id: 'agi-20',
    name: 'Arlequin',
    portrait: AGI20,
    category: 'Agility'
  },
  {
    id: 'agi-21',
    name: 'Estrath',
    portrait: AGI21,
    category: 'Agility'
  },
  {
    id: 'agi-22',
    name: 'Freya',
    portrait: AGI22,
    category: 'Agility'
  },
  {
    id: 'agi-23',
    name: 'Nightshade',
    portrait: AGI23,
    category: 'Agility'
  },
  {
    id: 'agi-24',
    name: 'Vince',
    portrait: AGI24,
    category: 'Agility'
  },
  {
    id: 'agi-25',
    name: 'Sun Wukong',
    portrait: AGI25,
    category: 'Agility'
  },
  {
    id: 'agi-26',
    name: 'Aiden',
    portrait: AGI26,
    category: 'Agility'
  },
  {
    id: 'agi-27',
    name: 'Electros',
    portrait: AGI27,
    category: 'Agility'
  },
  {
    id: 'agi-28',
    name: 'Mikio',
    portrait: AGI28,
    category: 'Agility'
  },
  {
    id: 'agi-29',
    name: 'Diana',
    portrait: AGI29,
    category: 'Agility'
  },
  {
    id: 'agi-30',
    name: 'Minerva',
    portrait: AGI30,
    category: 'Agility'
  },
  {
    id: 'agi-31',
    name: 'Raven',
    portrait: AGI31,
    category: 'Agility'
  },
  {
    id: 'agi-32',
    name: 'Nezha',
    portrait: AGI32,
    category: 'Agility'
  },
  {
    id: 'agi-33',
    name: 'Solus',
    portrait: AGI33,
    category: 'Agility'
  },
  {
    id: 'agi-34',
    name: 'Cao Cao',
    portrait: AGI34,
    category: 'Agility'
  },
  {
    id: 'agi-35',
    name: 'Magnolia',
    portrait: AGI35,
    category: 'Agility'
  },
  {
    id: 'agi-36',
    name: 'Pengwing',
    portrait: AGI36,
    category: 'Agility'
  },
  {
    id: 'agi-37',
    name: 'Zhao Yun',
    portrait: AGI37,
    category: 'Agility'
  },

  // ! - END - AGILITY HEROES

  // ! INTELLIGENCE HEROES
  {
    id: 'int-1',
    name: 'Hegemon',
    portrait: INT1,
    category: 'Intelligence'
  },
  {
    id: 'int-2',
    name: 'Xia Ling',
    portrait: INT2,
    category: 'Intelligence'
  },
  {
    id: 'int-3',
    name: 'Celestius',
    portrait: INT3,
    category: 'Intelligence'
  },
  {
    id: 'int-4',
    name: 'Albus',
    portrait: INT4,
    category: 'Intelligence'
  },
  {
    id: 'int-5',
    name: 'Athena',
    portrait: INT5,
    category: 'Intelligence'
  },
  {
    id: 'int-6',
    name: 'Lorelie',
    portrait: INT6,
    category: 'Intelligence'
  },
  {
    id: 'int-7',
    name: 'Chronos',
    portrait: INT7,
    category: 'Intelligence'
  },
  {
    id: 'int-8',
    name: 'Lin Lin',
    portrait: INT8,
    category: 'Intelligence'
  },
  {
    id: 'int-9',
    name: 'Yanbing Cao',
    portrait: INT9,
    category: 'Intelligence'
  },
  {
    id: 'int-10',
    name: 'Fleur',
    portrait: INT10,
    category: 'Intelligence'
  },
  {
    id: 'int-11',
    name: 'Chronia',
    portrait: INT11,
    category: 'Intelligence'
  },
  {
    id: 'int-12',
    name: 'Elvira',
    portrait: INT12,
    category: 'Intelligence'
  },
  {
    id: 'int-13',
    name: 'Absalon',
    portrait: INT13,
    category: 'Intelligence'
  },
  {
    id: 'int-14',
    name: 'Damacus',
    portrait: INT14,
    category: 'Intelligence'
  },
  {
    id: 'int-15',
    name: 'Zeus',
    portrait: INT15,
    category: 'Intelligence'
  },
  {
    id: 'int-16',
    name: 'Diao Chan',
    portrait: INT16,
    category: 'Intelligence'
  },
  {
    id: 'int-17',
    name: 'Zed',
    portrait: INT17,
    category: 'Intelligence'
  },
  {
    id: 'int-18',
    name: 'E-stein',
    portrait: INT18,
    category: 'Intelligence'
  },
  {
    id: 'int-19',
    name: 'Pandora',
    portrait: INT19,
    category: 'Intelligence'
  },
  {
    id: 'int-20',
    name: 'Arborus',
    portrait: INT20,
    category: 'Intelligence'
  },
  {
    id: 'int-21',
    name: 'Lotus',
    portrait: INT21,
    category: 'Intelligence'
  },
  {
    id: 'int-22',
    name: 'Pyrrhus',
    portrait: INT22,
    category: 'Intelligence'
  },
  {
    id: 'int-23',
    name: 'Una',
    portrait: INT23,
    category: 'Intelligence'
  },
  {
    id: 'int-24',
    name: 'Flavia',
    portrait: INT24,
    category: 'Intelligence'
  },
  {
    id: 'int-25',
    name: 'Jeanne',
    portrait: INT25,
    category: 'Intelligence'
  },
  {
    id: 'int-26',
    name: 'Cleopatra',
    portrait: INT26,
    category: 'Intelligence'
  },
  {
    id: 'int-27',
    name: 'Nosferatu',
    portrait: INT27,
    category: 'Intelligence'
  },
  {
    id: 'int-28',
    name: 'Poseidon',
    portrait: INT28,
    category: 'Intelligence'
  },
  {
    id: 'int-29',
    name: 'Magicka',
    portrait: INT29,
    category: 'Intelligence'
  },
  {
    id: 'int-30',
    name: 'Saya',
    portrait: INT30,
    category: 'Intelligence'
  },
  {
    id: 'int-31',
    name: 'Yuki',
    portrait: INT31,
    category: 'Intelligence'
  },
  {
    id: 'int-32',
    name: 'Lunaria',
    portrait: INT32,
    category: 'Intelligence'
  },
  {
    id: 'int-33',
    name: 'Crystal',
    portrait: INT33,
    category: 'Intelligence'
  }

  // ! - END - INTELLIGENCE HEROES
]